/**
 * Full 120-item interest bank (slug interest-test). Each attempt uses 40 random items.
 * Generated from scripts/new-interest-question — regenerate: npm run papers:generate-interest
 */
export const simplifiedInterestTestPaper = {
  "slug": "interest-test",
  "title": {
    "en": "Interest Test",
    "tc": "興趣測驗",
    "sc": "兴趣测验"
  },
  "paperInstruction": {
    "en": "Instructions: Each session shows 40 randomly chosen activities from our full bank of 120. Read each statement and say how much it sounds like you. Swipe right for Agree, down for Neutral, and left for Disagree. There is no time limit.",
    "tc": "作答說明：每次測驗會從 120 項活動中隨機抽選 40 題。請閱讀每句陳述，並指出其在日常生活中有多符合你。向右滑表示同意、向下滑表示中立、向左滑表示不同意。本測驗不限時。",
    "sc": "作答说明：每次测验会从 120 项活动中随机抽选 40 题。请阅读每句陈述，并指出其在日常生活中有多符合你。向右滑表示同意、向下滑表示中立、向左滑表示不同意。本测验不限时。"
  },
  "timeLimitSeconds": 0,
  "order": 0,
  "isPublished": true,
  "sections": [
    {
      "id": "statements",
      "title": {
        "en": "Activities",
        "tc": "活動",
        "sc": "活动"
      },
      "passages": [],
      "questions": [
        {
          "id": "sit_1",
          "displayNumber": 1,
          "passageId": null,
          "prompt": {
            "en": "Discussing whether a school rule is fair or unfair.",
            "tc": "討論學校規矩公唔公平。",
            "sc": "我乐于讨论学校规章是否公平合理。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_2",
          "displayNumber": 2,
          "passageId": null,
          "prompt": {
            "en": "Suggesting ways to tackle social problems in society.",
            "tc": "諗方法解決社會上嘅問題。",
            "sc": "我热衷于提出解决社会问题的方案。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_3",
          "displayNumber": 3,
          "passageId": null,
          "prompt": {
            "en": "Planning how a small school booth could earn money.",
            "tc": "策劃學校小攤位點樣賺錢。",
            "sc": "我乐于规划学校摊位如何盈利。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_4",
          "displayNumber": 4,
          "passageId": null,
          "prompt": {
            "en": "Designing posters or slogans that attract people to an event.",
            "tc": "設計吸引人去活動嘅海報同標語。",
            "sc": "我习惯于设计吸引人们参与活动的海报与标语。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_5",
          "displayNumber": 5,
          "passageId": null,
          "prompt": {
            "en": "Learning how an app or website is built.",
            "tc": "學 app 或者網站點樣整出嚟。",
            "sc": "我热衷于了解应用程序或网站的构建方式。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_6",
          "displayNumber": 6,
          "passageId": null,
          "prompt": {
            "en": "Building simple devices that move, light up, or make sound.",
            "tc": "砌會郁、發光或者出聲嘅簡單裝置。",
            "sc": "我乐于制作会运动、发光或发声的简单装置。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_7",
          "displayNumber": 7,
          "passageId": null,
          "prompt": {
            "en": "Sketching a better layout for a classroom, library, or study area.",
            "tc": "畫教室、圖書館或者自修區更好嘅佈局。",
            "sc": "我习惯于勾勒教室、图书馆或自习区更合理的布局。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_8",
          "displayNumber": 8,
          "passageId": null,
          "prompt": {
            "en": "Learning how the human body reacts when someone is sick or injured.",
            "tc": "學人病咗或者受傷時身體有咩反應。",
            "sc": "我热衷于了解人体在疾病或受伤时的反应机制。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_9",
          "displayNumber": 9,
          "passageId": null,
          "prompt": {
            "en": "Listening carefully when a friend explains a personal problem.",
            "tc": "朋友講心事時會好專心聽。",
            "sc": "我习惯于在朋友倾诉个人问题时认真倾听。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_10",
          "displayNumber": 10,
          "passageId": null,
          "prompt": {
            "en": "Explaining a difficult homework question to a younger student.",
            "tc": "幫細過嘅同學解答難嘅功課題。",
            "sc": "我乐于向低年级学生讲解较难的作业题目。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_11",
          "displayNumber": 11,
          "passageId": null,
          "prompt": {
            "en": "Observing plants, animals, or microorganisms and recording changes.",
            "tc": "觀察植物、動物或者微生物並記低變化。",
            "sc": "我习惯于观察植物、动物或微生物并记录其变化。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_12",
          "displayNumber": 12,
          "passageId": null,
          "prompt": {
            "en": "Testing how different materials react when mixed, heated, or cooled.",
            "tc": "測試唔同物料混合、加熱或者冷卻有咩反應。",
            "sc": "我热衷于测试不同材料在混合、加热或冷却条件下的反应。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_13",
          "displayNumber": 13,
          "passageId": null,
          "prompt": {
            "en": "Using formulas to explain motion, energy, light, or sound.",
            "tc": "用公式解釋運動、能量、光同聲音。",
            "sc": "我习惯于运用公式解释运动、能量、光与声等现象。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_14",
          "displayNumber": 14,
          "passageId": null,
          "prompt": {
            "en": "Creating drawings, graphics, or visual layouts for a project.",
            "tc": "為項目畫圖、做圖像或者視覺排版。",
            "sc": "我乐于为项目创作绘画、图形或视觉版面设计。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_15",
          "displayNumber": 15,
          "passageId": null,
          "prompt": {
            "en": "Performing music, drama, dance, or spoken performance in front of others.",
            "tc": "喺人面前表演音樂、戲劇、舞蹈或者口語表演。",
            "sc": "我习惯于在众人面前进行音乐、戏剧、舞蹈或口语表演。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_16",
          "displayNumber": 16,
          "passageId": null,
          "prompt": {
            "en": "Writing a short story, poem, article, review, or script.",
            "tc": "寫短篇故事、詩、文章、評論或者劇本。",
            "sc": "我乐于撰写短篇故事、诗歌、文章、评论或剧本。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_17",
          "displayNumber": 17,
          "passageId": null,
          "prompt": {
            "en": "Filming or editing a short video for a school activity.",
            "tc": "為學校活動拍片或者剪片。",
            "sc": "我习惯于为学校活动拍摄或剪辑短视频。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_18",
          "displayNumber": 18,
          "passageId": null,
          "prompt": {
            "en": "Helping plan a trip, tour, exhibition, or guest activity.",
            "tc": "幫手策劃旅行、導賞、展覽或者嘉賓活動。",
            "sc": "我乐于协助策划旅行、导览、展览或嘉宾活动。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_19",
          "displayNumber": 19,
          "passageId": null,
          "prompt": {
            "en": "Training to improve my strength, speed, flexibility, or sports skills.",
            "tc": "訓練提升自己力量、速度、柔韌度或者運動技術。",
            "sc": "我致力于通过训练提升力量、速度、柔韧度或运动技能。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_20",
          "displayNumber": 20,
          "passageId": null,
          "prompt": {
            "en": "Translating or explaining ideas between different languages or cultures.",
            "tc": "喺唔同語言或者文化之間翻譯或者解釋想法。",
            "sc": "我习惯于在不同语言或文化之间翻译或阐释观点。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_21",
          "displayNumber": 21,
          "passageId": null,
          "prompt": {
            "en": "Learning why historical events happened and how they affect today.",
            "tc": "學歷史事件點解發生、點影響今日。",
            "sc": "我热衷于了解历史事件的成因及其对当今的影响。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_22",
          "displayNumber": 22,
          "passageId": null,
          "prompt": {
            "en": "Using survey results or data to find patterns in people’s opinions.",
            "tc": "用問卷或者數據搵出人意見嘅規律。",
            "sc": "我习惯于运用调查数据发现公众意见的规律。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_23",
          "displayNumber": 23,
          "passageId": null,
          "prompt": {
            "en": "Organizing people, time, materials, and tasks for an event.",
            "tc": "為活動安排人手、時間、物資同任務。",
            "sc": "我乐于为活动统筹人员、时间、物资与任务分工。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_24",
          "displayNumber": 24,
          "passageId": null,
          "prompt": {
            "en": "Designing or improving a simple recipe, drink, snack, or meal.",
            "tc": "設計或者改良簡單食譜、飲品、小食或者一餐飯。",
            "sc": "我习惯于设计或改良简易食谱、饮品、小食或餐点。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_25",
          "displayNumber": 25,
          "passageId": null,
          "prompt": {
            "en": "Arguing both sides of a disagreement before deciding my view.",
            "tc": "未決定立場前先辯論爭議雙方觀點。",
            "sc": "我习惯于在形成观点前正反两面论证分歧议题。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_26",
          "displayNumber": 26,
          "passageId": null,
          "prompt": {
            "en": "Comparing different solutions to poverty, inequality, or housing problems.",
            "tc": "比較解決貧窮、不平等或者住屋問題嘅唔同方案。",
            "sc": "我热衷于比较解决贫困、不平等或住房问题的不同方案。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_27",
          "displayNumber": 27,
          "passageId": null,
          "prompt": {
            "en": "Creating a budget for a class activity, club, or trip.",
            "tc": "為班級活動、學會或者旅行制定預算。",
            "sc": "我习惯于为班级活动、社团或旅行编制预算。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_28",
          "displayNumber": 28,
          "passageId": null,
          "prompt": {
            "en": "Understanding why people choose one brand, product, or shop over another.",
            "tc": "了解點解人會揀某個品牌、產品或者店舖。",
            "sc": "我热衷于理解人们选择某一品牌、产品或店铺的原因。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_29",
          "displayNumber": 29,
          "passageId": null,
          "prompt": {
            "en": "Fixing a simple bug in code or finding why a program does not work.",
            "tc": "改程式嘅簡單 bug 或者搵出點解程式運作唔到。",
            "sc": "我习惯于修复代码中的简单错误并排查程序故障原因。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_30",
          "displayNumber": 30,
          "passageId": null,
          "prompt": {
            "en": "Joining a robotics, drone, or engineering challenge.",
            "tc": "參加機械人、無人機或者工程挑戰賽。",
            "sc": "我乐于参与机器人、无人机或工程挑战赛。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_31",
          "displayNumber": 31,
          "passageId": null,
          "prompt": {
            "en": "Thinking about how buildings can be safer, greener, or more comfortable.",
            "tc": "諗建築點樣更安全、更環保或者更舒適。",
            "sc": "我习惯于思考建筑如何更安全、环保或舒适。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_32",
          "displayNumber": 32,
          "passageId": null,
          "prompt": {
            "en": "Observing how doctors, nurses, or therapists care for patients.",
            "tc": "觀察醫生、護士或者治療師點樣照顧病人。",
            "sc": "我热衷于观察医护人员如何照护患者。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_33",
          "displayNumber": 33,
          "passageId": null,
          "prompt": {
            "en": "Learning why people behave differently when they are stressed.",
            "tc": "學點解人受壓時行為會唔同。",
            "sc": "我热衷于了解人在压力状态下行为各异的原因。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_34",
          "displayNumber": 34,
          "passageId": null,
          "prompt": {
            "en": "Designing a simple activity that helps others learn something faster.",
            "tc": "設計簡單活動幫人更快學嘢。",
            "sc": "我乐于设计简易活动以帮助他人更快学会相关内容。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_35",
          "displayNumber": 35,
          "passageId": null,
          "prompt": {
            "en": "Investigating how pollution affects people, animals, or the environment.",
            "tc": "研究污染點影響人、動物同環境。",
            "sc": "我热衷于研究污染对人类、动物及环境的影响。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_36",
          "displayNumber": 36,
          "passageId": null,
          "prompt": {
            "en": "Carrying out a lab experiment carefully and record the results.",
            "tc": "小心做實驗室實驗並記低結果。",
            "sc": "我习惯于认真完成实验室实验并记录结果。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_37",
          "displayNumber": 37,
          "passageId": null,
          "prompt": {
            "en": "Solving problems that involve numbers, graphs, or logical steps.",
            "tc": "解答涉及數字、圖表或者邏輯步驟嘅問題。",
            "sc": "我善于解决涉及数字、图表或逻辑推理的问题。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_38",
          "displayNumber": 38,
          "passageId": null,
          "prompt": {
            "en": "Designing a logo, character, clothing item, product, or packaging.",
            "tc": "設計 logo、角色、衫、產品或者包裝。",
            "sc": "我乐于设计标识、角色、服饰、产品或包装。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_39",
          "displayNumber": 39,
          "passageId": null,
          "prompt": {
            "en": "Practicing a performance many times until it feels expressive and polished.",
            "tc": "反覆練習表演直到夠感染力同落堂。",
            "sc": "我习惯于反复排练表演直至富有表现力且精湛。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_40",
          "displayNumber": 40,
          "passageId": null,
          "prompt": {
            "en": "Editing someone’s writing to make it clearer, stronger, or more interesting.",
            "tc": "幫人改文章令佢更清晰、更有力或者更有趣。",
            "sc": "我乐于修改他人文字使其更清晰、有力或更精彩。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_41",
          "displayNumber": 41,
          "passageId": null,
          "prompt": {
            "en": "Interviewing someone and turning their story into a video, article, or post.",
            "tc": "訪問某人並將佢嘅故事拍成影片、文章或者帖文。",
            "sc": "我习惯于采访他人并将其故事转化为视频、文章或帖子。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_42",
          "displayNumber": 42,
          "passageId": null,
          "prompt": {
            "en": "Welcoming guests and help them have a smooth and enjoyable experience.",
            "tc": "迎接賓客並幫佢哋有順利又開心嘅體驗。",
            "sc": "我乐于接待宾客并协助其获得顺畅愉快的体验。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_43",
          "displayNumber": 43,
          "passageId": null,
          "prompt": {
            "en": "Teaching someone a sport, dance move, exercise, or physical skill.",
            "tc": "教別人運動、跳舞、健身或者體能技巧。",
            "sc": "我习惯于教授他人运动、舞蹈动作、健身或体能技能。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_44",
          "displayNumber": 44,
          "passageId": null,
          "prompt": {
            "en": "Learning a foreign language because I am curious about its people and culture.",
            "tc": "因為好奇嗰個地方嘅人同文化而學外語。",
            "sc": "我因对当地人民与文化的好奇而学习外语。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_45",
          "displayNumber": 45,
          "passageId": null,
          "prompt": {
            "en": "Visiting a museum, heritage site, or old district and explaining its meaning.",
            "tc": "參觀博物館、古蹟或者舊區並講解背後意義。",
            "sc": "我习惯于参观博物馆、遗迹或旧区并阐释其历史文化意义。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_46",
          "displayNumber": 46,
          "passageId": null,
          "prompt": {
            "en": "Making charts or infographics that help people understand information.",
            "tc": "整圖表或者資訊圖幫人理解資料。",
            "sc": "我乐于制作图表或信息图以帮助人们理解信息。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_47",
          "displayNumber": 47,
          "passageId": null,
          "prompt": {
            "en": "Making a checklist and timeline so a project can finish on time.",
            "tc": "列清單同時間表確保項目準時完成。",
            "sc": "我习惯于制定清单与时间表以确保项目按时完成。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_48",
          "displayNumber": 48,
          "passageId": null,
          "prompt": {
            "en": "Learning how nutrition affects energy, mood, sport, or health.",
            "tc": "學營養點影響精力、情緒、運動同健康。",
            "sc": "我热衷于了解营养如何影响精力、情绪、运动与健康。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_49",
          "displayNumber": 49,
          "passageId": null,
          "prompt": {
            "en": "Reading about a legal case and identify the evidence and arguments.",
            "tc": "閱讀法律案件並找出證據同論點。",
            "sc": "我习惯于研读法律案例并辨识证据与论据。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_50",
          "displayNumber": 50,
          "passageId": null,
          "prompt": {
            "en": "Discussing how government decisions affect students and families.",
            "tc": "討論政府決定點影響學生同家庭。",
            "sc": "我乐于讨论政府决策对学生与家庭的影响。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_51",
          "displayNumber": 51,
          "passageId": null,
          "prompt": {
            "en": "Thinking of a new product or service that students may want to use.",
            "tc": "諗學生可能想用嘅新產品或者服務。",
            "sc": "我习惯于构想学生可能乐于使用的新产品或服务。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_52",
          "displayNumber": 52,
          "passageId": null,
          "prompt": {
            "en": "Planning a social media campaign for a school event or club.",
            "tc": "為學校活動或者學會策劃社交媒體宣傳。",
            "sc": "我乐于为学校活动或社团策划社交媒体推广。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_53",
          "displayNumber": 53,
          "passageId": null,
          "prompt": {
            "en": "Creating a chatbot, simple game, or small digital tool.",
            "tc": "整 chatbot、簡單遊戲或者細數碼工具。",
            "sc": "我热衷于开发聊天机器人、简易游戏或小型数字工具。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_54",
          "displayNumber": 54,
          "passageId": null,
          "prompt": {
            "en": "Finding why a machine, toy, appliance, or gadget stops working.",
            "tc": "搵出機器、玩具、電器或者 gadget 點解壞咗。",
            "sc": "我习惯于查明机器、玩具、电器或装置故障的原因。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_55",
          "displayNumber": 55,
          "passageId": null,
          "prompt": {
            "en": "Observing how people move through MTR stations, malls, streets, or school environments.",
            "tc": "觀察人喺港鐵站、商場、街道或者校園點樣走動。",
            "sc": "我习惯于观察人们在港铁站、商场、街道或校园中的动线。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_56",
          "displayNumber": 56,
          "passageId": null,
          "prompt": {
            "en": "Learning how medicines, vaccines, or medical tests work.",
            "tc": "學藥物、疫苗或者醫學檢測點樣運作。",
            "sc": "我热衷于了解药物、疫苗或医学检测的原理。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_57",
          "displayNumber": 57,
          "passageId": null,
          "prompt": {
            "en": "Helping new students feel included and less nervous at school.",
            "tc": "幫新同學融入學校、冇咁緊張。",
            "sc": "我乐于帮助新生融入校园并减轻其紧张情绪。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_58",
          "displayNumber": 58,
          "passageId": null,
          "prompt": {
            "en": "Being a peer tutor, mentor, house leader, or group learning helper.",
            "tc": "做同輩導師、師兄師姐、舍堂領袖或者小組學習幫手。",
            "sc": "我习惯于担任同伴导师、学长、舍堂领袖或小组学习助手。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_59",
          "displayNumber": 59,
          "passageId": null,
          "prompt": {
            "en": "Joining a project on recycling, food waste, energy saving, or nature protection.",
            "tc": "參加回收、廚餘、慳電或者自然保護項目。",
            "sc": "我乐于参与回收、厨余、节能或自然保护相关项目。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_60",
          "displayNumber": 60,
          "passageId": null,
          "prompt": {
            "en": "Comparing different chemicals, foods, or materials to see how their properties differ.",
            "tc": "比較唔同化學品、食物或者物料嘅特性有咩分別。",
            "sc": "我习惯于比较不同化学品、食物或材料的性质差异。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_61",
          "displayNumber": 61,
          "passageId": null,
          "prompt": {
            "en": "Understanding how aircraft, rockets, satellites, or space technology work.",
            "tc": "了解飛機、火箭、衛星或者太空科技點樣運作。",
            "sc": "我热衷于理解飞机、火箭、卫星或航天技术的原理。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_62",
          "displayNumber": 62,
          "passageId": null,
          "prompt": {
            "en": "Improving the colour, shape, style, or visual feeling of an object.",
            "tc": "改善物件嘅顏色、形狀、風格或者視覺感覺。",
            "sc": "我乐于改善物品的色彩、造型、风格或视觉感受。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_63",
          "displayNumber": 63,
          "passageId": null,
          "prompt": {
            "en": "Helping write or direct a drama, music, dance, or stage performance.",
            "tc": "幫手寫或者執導戲劇、音樂、舞蹈或者舞台表演。",
            "sc": "我习惯于协助编写或执导戏剧、音乐、舞蹈或舞台演出。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_64",
          "displayNumber": 64,
          "passageId": null,
          "prompt": {
            "en": "Reading literature and discussing what the writer is trying to express.",
            "tc": "讀文學作品並討論作者想表達咩。",
            "sc": "我习惯于阅读文学作品并探讨作者的表达意图。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_65",
          "displayNumber": 65,
          "passageId": null,
          "prompt": {
            "en": "Taking photos or videos that tell a clear story or create a mood.",
            "tc": "影相或者拍片講清楚故事或者營造氣氛。",
            "sc": "我乐于拍摄能讲述清晰故事或营造氛围的照片或视频。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_66",
          "displayNumber": 66,
          "passageId": null,
          "prompt": {
            "en": "Arranging food, rooms, signs, or schedules so guests feel comfortable.",
            "tc": "安排食物、房間、指示牌或者行程令賓客舒服。",
            "sc": "我习惯于安排餐饮、场地、标识或日程以使宾客感到舒适。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_67",
          "displayNumber": 67,
          "passageId": null,
          "prompt": {
            "en": "Analysing why an athlete or team performed well or badly.",
            "tc": "分析運動員或者球隊點解表現好或者差。",
            "sc": "我热衷于分析运动员或团队表现优劣的原因。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_68",
          "displayNumber": 68,
          "passageId": null,
          "prompt": {
            "en": "Comparing how different cultures express politeness, humour, or emotion.",
            "tc": "比較唔同文化點表達禮貌、幽默或者情緒。",
            "sc": "我习惯于比较不同文化在礼貌、幽默或情感表达上的差异。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_69",
          "displayNumber": 69,
          "passageId": null,
          "prompt": {
            "en": "Researching the history of a family, building, street, object, or community.",
            "tc": "研究一個家庭、建築、街道、物件或者社區嘅歷史。",
            "sc": "我热衷于研究家庭、建筑、街道、物品或社区的历史。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_70",
          "displayNumber": 70,
          "passageId": null,
          "prompt": {
            "en": "Using data to check whether a popular belief is actually true.",
            "tc": "用數據驗證流行說法係咪真。",
            "sc": "我习惯于运用数据检验流行说法是否属实。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_71",
          "displayNumber": 71,
          "passageId": null,
          "prompt": {
            "en": "Managing equipment, bookings, people, or resources behind the scenes.",
            "tc": "喺幕後管理設備、預約、人手或者資源。",
            "sc": "我习惯于在幕后管理设备、预订、人员或资源。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_72",
          "displayNumber": 72,
          "passageId": null,
          "prompt": {
            "en": "Learning cooking techniques such as baking, plating, seasoning, or food preparation.",
            "tc": "學烘焙、擺盤、調味或者備料等烹飪技巧。",
            "sc": "我热衷于学习烘焙、摆盘、调味或备料等烹饪技艺。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_73",
          "displayNumber": 73,
          "passageId": null,
          "prompt": {
            "en": "Helping classmates express their opinions in a meeting or discussion.",
            "tc": "幫同學喺會議或者討論中表達意見。",
            "sc": "我乐于协助同学在会议或讨论中表达观点。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_74",
          "displayNumber": 74,
          "passageId": null,
          "prompt": {
            "en": "Debating how limited resources should be shared in society.",
            "tc": "辯論社會有限資源應該點分配。",
            "sc": "我习惯于辩论社会中有限资源应如何分配。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_75",
          "displayNumber": 75,
          "passageId": null,
          "prompt": {
            "en": "Checking whether a business idea is realistic or too risky.",
            "tc": "檢視生意構思係咪可行或者太冒險。",
            "sc": "我习惯于评估商业构想是否可行或过于冒险。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_76",
          "displayNumber": 76,
          "passageId": null,
          "prompt": {
            "en": "Comparing two advertisements and explain which one is more persuasive.",
            "tc": "比較兩個廣告並講邊個更有說服力。",
            "sc": "我习惯于比较两则广告并阐释何者更具说服力。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_77",
          "displayNumber": 77,
          "passageId": null,
          "prompt": {
            "en": "Learning how hackers break into systems and how to prevent it.",
            "tc": "學黑客點入侵系統同點樣防範。",
            "sc": "我热衷于了解黑客入侵系统的手段及防范措施。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_78",
          "displayNumber": 78,
          "passageId": null,
          "prompt": {
            "en": "Designing a prototype, test it, and improve it after failure.",
            "tc": "設計原型、測試、失敗之後再改良。",
            "sc": "我习惯于设计原型、开展测试并在失败后予以改进。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_79",
          "displayNumber": 79,
          "passageId": null,
          "prompt": {
            "en": "Designing a small public space where students or families can relax.",
            "tc": "設計俾學生或者家庭放鬆嘅小型公共空間。",
            "sc": "我乐于设计供学生或家庭休憩的小型公共空间。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_80",
          "displayNumber": 80,
          "passageId": null,
          "prompt": {
            "en": "Practicing explaining health information clearly to a patient or family member.",
            "tc": "練習清楚向病人或者家人解釋健康資訊。",
            "sc": "我习惯于练习向患者或家属清晰阐释健康信息。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_81",
          "displayNumber": 81,
          "passageId": null,
          "prompt": {
            "en": "Planning support for classmates who feel lonely, anxious, or left out.",
            "tc": "為感到孤單、焦慮或者被冷落嘅同學策劃支援。",
            "sc": "我乐于为感到孤独、焦虑或被疏远的同学规划支持方案。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_82",
          "displayNumber": 82,
          "passageId": null,
          "prompt": {
            "en": "Creating worksheets, quizzes, learning videos, or learning games.",
            "tc": "製作工作紙、測驗、學習片或者學習遊戲。",
            "sc": "我热衷于制作工作纸、测验、学习视频或学习游戏。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_83",
          "displayNumber": 83,
          "passageId": null,
          "prompt": {
            "en": "Studying how diseases spread among humans, animals, or plants.",
            "tc": "研究疾病喺人、動物或者植物之間點傳播。",
            "sc": "我热衷于研究疾病在人类、动物或植物间的传播规律。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_84",
          "displayNumber": 84,
          "passageId": null,
          "prompt": {
            "en": "Learning how food science, cosmetics, batteries, or materials are tested.",
            "tc": "學食品科學、化妝品、電池或者物料點樣測試。",
            "sc": "我热衷于了解食品科学、化妆品、电池或材料的检测方法。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_85",
          "displayNumber": 85,
          "passageId": null,
          "prompt": {
            "en": "Using maths or physics to predict what will happen in a real situation.",
            "tc": "用數學或者物理預測現實情況會點。",
            "sc": "我习惯于运用数学或物理预测现实情境中的结果。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_86",
          "displayNumber": 86,
          "passageId": null,
          "prompt": {
            "en": "Making illustrations, animations, or visual designs for digital content.",
            "tc": "為數碼內容畫插圖、做動畫或者視覺設計。",
            "sc": "我乐于为数字内容制作插画、动画或视觉设计。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_87",
          "displayNumber": 87,
          "passageId": null,
          "prompt": {
            "en": "Choosing music, movement, voice, lighting, or costume to create a mood.",
            "tc": "揀音樂、動作、聲線、燈光或者服裝營造氣氛。",
            "sc": "我习惯于选择音乐、动作、嗓音、灯光或服装以营造氛围。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_88",
          "displayNumber": 88,
          "passageId": null,
          "prompt": {
            "en": "Writing a speech, article, or post that changes how people think or feel.",
            "tc": "寫演講、文章或者帖文去改變人嘅想法或者感受。",
            "sc": "我热衷于撰写能改变人们思想或情感的演讲、文章或帖子。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_89",
          "displayNumber": 89,
          "passageId": null,
          "prompt": {
            "en": "Editing audio, images, clips, subtitles, or effects to improve a video.",
            "tc": "剪輯音頻、圖像、片段、字幕或者特效改善影片。",
            "sc": "我习惯于编辑音频、图像、片段、字幕或特效以提升视频质量。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_90",
          "displayNumber": 90,
          "passageId": null,
          "prompt": {
            "en": "Solving problems quickly when an event, tour, or activity does not go as planned.",
            "tc": "活動、導賞或者行程出問題時快速應變。",
            "sc": "我善于在活动、导览或行程偏离计划时迅速解决问题。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_91",
          "displayNumber": 91,
          "passageId": null,
          "prompt": {
            "en": "Planning exercise routines that help people become healthier or fitter.",
            "tc": "設計運動計劃幫人更健康或者更有活力。",
            "sc": "我习惯于规划有助人们增强体质的运动方案。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_92",
          "displayNumber": 92,
          "passageId": null,
          "prompt": {
            "en": "Acting as a bridge between people who speak different languages.",
            "tc": "做唔同語言人士之間嘅橋樑。",
            "sc": "我习惯于充当不同语言使用者之间的沟通桥梁。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_93",
          "displayNumber": 93,
          "passageId": null,
          "prompt": {
            "en": "Comparing past and present Hong Kong lifestyles, values, or communities.",
            "tc": "比較香港過去同而家嘅生活方式、價值觀或者社區。",
            "sc": "我热衷于比较香港过去与现今的生活方式、价值观或社区风貌。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_94",
          "displayNumber": 94,
          "passageId": null,
          "prompt": {
            "en": "Designing questionnaires and am confident in analysing the answers carefully.",
            "tc": "設計問卷並有信心仔細分析答案。",
            "sc": "我自信能够设计问卷并认真分析答卷结果。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_95",
          "displayNumber": 95,
          "passageId": null,
          "prompt": {
            "en": "Coordinating a team so everyone knows what to do next.",
            "tc": "協調團隊令大家知道下一步做咩。",
            "sc": "我乐于协调团队使每位成员明确下一步工作。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_96",
          "displayNumber": 96,
          "passageId": null,
          "prompt": {
            "en": "Planning a balanced meal for different needs, such as athletes, children, or elderly people.",
            "tc": "為運動員、小朋友或者長者等唔同需要設計均衡餐單。",
            "sc": "我习惯于为运动员、儿童或长者等不同需求规划均衡膳食。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_97",
          "displayNumber": 97,
          "passageId": null,
          "prompt": {
            "en": "Researching a social issue and explain what law or policy could improve it.",
            "tc": "研究社會議題並解釋咩法律或者政策可以改善。",
            "sc": "我热衷于研究社会议题并阐释可予改善的法律法规或政策。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_98",
          "displayNumber": 98,
          "passageId": null,
          "prompt": {
            "en": "Studying why some cities or countries become richer, safer, or more developed than others.",
            "tc": "研究點解有啲城市或者國家比其他更富、更安全或者更發達。",
            "sc": "我热衷于研究部分城市或国家更为富裕、安全或发达的原因。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_99",
          "displayNumber": 99,
          "passageId": null,
          "prompt": {
            "en": "Studying how companies make money and why some businesses fail.",
            "tc": "研究公司點賺錢同點解有啲生意會失敗。",
            "sc": "我热衷于研究企业盈利方式及若干生意失败的原因。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_100",
          "displayNumber": 100,
          "passageId": null,
          "prompt": {
            "en": "Asking students what they like, then using their answers to improve an idea.",
            "tc": "問學生鍾意咩，再用佢哋答案改良構思。",
            "sc": "我习惯于征询学生喜好并据此完善创意方案。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_101",
          "displayNumber": 101,
          "passageId": null,
          "prompt": {
            "en": "Using AI tools to solve real school or daily-life problems.",
            "tc": "用 AI 工具解決學校或者日常生活嘅實際問題。",
            "sc": "我热衷于运用人工智能工具解决学校或生活中的实际问题。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_102",
          "displayNumber": 102,
          "passageId": null,
          "prompt": {
            "en": "Using physics ideas to solve practical problems in daily life.",
            "tc": "用物理概念解決日常生活嘅實際問題。",
            "sc": "我习惯于运用物理原理解决日常生活中的实际问题。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_103",
          "displayNumber": 103,
          "passageId": null,
          "prompt": {
            "en": "Comparing different housing designs and explain which one works better.",
            "tc": "比較唔同房屋設計並講邊個更可行。",
            "sc": "我习惯于比较不同住宅设计并阐释何者更为适宜。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_104",
          "displayNumber": 104,
          "passageId": null,
          "prompt": {
            "en": "Studying real health cases and deciding what support a person may need.",
            "tc": "研究真實健康個案並判斷當事人需要咩支援。",
            "sc": "我热衷于研究真实健康案例并判断当事人所需的支持。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_105",
          "displayNumber": 105,
          "passageId": null,
          "prompt": {
            "en": "Learning how family, school, friends, and society affect a person’s choices.",
            "tc": "學家庭、學校、朋友同社會點影響一個人嘅選擇。",
            "sc": "我热衷于了解家庭、学校、朋友及社会如何影响个人抉择。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_106",
          "displayNumber": 106,
          "passageId": null,
          "prompt": {
            "en": "Finding different ways to teach the same idea to different types of learners.",
            "tc": "搵唔同方法教同一個概念俾唔同類型嘅學習者。",
            "sc": "我习惯于针对不同类型的学习者采用多元方式传授同一概念。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_107",
          "displayNumber": 107,
          "passageId": null,
          "prompt": {
            "en": "Collecting environmental data, such as temperature, air quality, water quality, or biodiversity.",
            "tc": "收集環境數據，例如溫度、空氣質素、水質或者生物多樣性。",
            "sc": "我习惯于采集温度、空气质量、水质或生物多样性等环境数据。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_108",
          "displayNumber": 108,
          "passageId": null,
          "prompt": {
            "en": "Following strict safety steps during a science experiment.",
            "tc": "做科學實驗時嚴格遵守安全步驟。",
            "sc": "我习惯于在科学实验中严格遵守安全规程。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_109",
          "displayNumber": 109,
          "passageId": null,
          "prompt": {
            "en": "Exploring advanced maths ideas even when they are challenging.",
            "tc": "即使好難都仲會探索進階數學概念。",
            "sc": "即使颇具难度，我仍乐于探索高等数学概念。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_110",
          "displayNumber": 110,
          "passageId": null,
          "prompt": {
            "en": "Creating a portfolio of drawings, photos, designs, or visual experiments.",
            "tc": "整作品集，包括畫作、相片、設計或者視覺實驗。",
            "sc": "我乐于创作涵盖绘画、摄影、设计或视觉实验的作品集。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_111",
          "displayNumber": 111,
          "passageId": null,
          "prompt": {
            "en": "Performing, hosting, or speaking at a school event.",
            "tc": "喺學校活動表演、主持或者演講。",
            "sc": "我习惯于在学校活动中表演、主持或演讲。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_112",
          "displayNumber": 112,
          "passageId": null,
          "prompt": {
            "en": "Building a world, character, argument, or message through writing.",
            "tc": "透過寫作建立世界觀、角色、論點或者訊息。",
            "sc": "我热衷于以文字构建世界观、人物、论点或核心讯息。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_113",
          "displayNumber": 113,
          "passageId": null,
          "prompt": {
            "en": "Reporting on school, community, entertainment, or social issues in a fair and engaging way.",
            "tc": "以公正又吸引嘅方式報道學校、社區、娛樂或者社會議題。",
            "sc": "我习惯于以公正且生动的方式报道学校、社区、娱乐或社会议题。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_114",
          "displayNumber": 114,
          "passageId": null,
          "prompt": {
            "en": "Designing an event experience, such as the theme, flow, atmosphere, and guest journey.",
            "tc": "設計活動體驗，例如主題、流程、氣氛同賓客動線。",
            "sc": "我乐于设计活动体验，涵盖主题、流程、氛围与宾客动线。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_115",
          "displayNumber": 115,
          "passageId": null,
          "prompt": {
            "en": "Studying injury prevention, body movement, or sports performance.",
            "tc": "研究預防受傷、身體動作或者運動表現。",
            "sc": "我热衷于研究损伤预防、身体动作或运动表现。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_116",
          "displayNumber": 116,
          "passageId": null,
          "prompt": {
            "en": "Helping visitors or classmates understand another culture without stereotypes.",
            "tc": "幫訪客或者同學了解另一種文化、唔帶刻板印象。",
            "sc": "我乐于帮助访客或同学不带成见地了解其他文化。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_117",
          "displayNumber": 117,
          "passageId": null,
          "prompt": {
            "en": "Preserving stories, traditions, photos, records, or objects for future people.",
            "tc": "保存故事、傳統、相片、紀錄或者物件俾後人。",
            "sc": "我热衷于为后人保存故事、传统、照片、档案或物件。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_118",
          "displayNumber": 118,
          "passageId": null,
          "prompt": {
            "en": "Testing whether a result is reliable or just caused by chance.",
            "tc": "測試結果係咪可靠抑或只係偶然。",
            "sc": "我习惯于检验结果是否可靠抑或仅为偶然所致。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_119",
          "displayNumber": 119,
          "passageId": null,
          "prompt": {
            "en": "Improving a messy process so people waste less time, money, or effort.",
            "tc": "改善混亂流程令人少浪費時間、金錢同精力。",
            "sc": "我习惯于优化繁杂流程以减少人们的时间、金钱或精力浪费。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        },
        {
          "id": "sit_120",
          "displayNumber": 120,
          "passageId": null,
          "prompt": {
            "en": "Creating food or drinks that look good, taste good, and suit a target group.",
            "tc": "整又好睇、又好味、又啱目標客群嘅食物或者飲品。",
            "sc": "我乐于创作外观精美、味道鲜美且适合目标群体的饮食。"
          },
          "options": [
            {
              "key": "1",
              "label": {
                "en": "Agree",
                "tc": "同意",
                "sc": "同意"
              }
            },
            {
              "key": "0",
              "label": {
                "en": "Neutral",
                "tc": "中立",
                "sc": "中立"
              }
            },
            {
              "key": "-1",
              "label": {
                "en": "Disagree",
                "tc": "不同意",
                "sc": "不同意"
              }
            }
          ]
        }
      ]
    }
  ]
};
